import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'
import { createMediaProjection } from '../projections/createMediaProjection'
import { createLinkProjection } from '../projections/createLinkProjection'

export const createSectionOpenPositionsProjection = (localeId: LocaleId) => {
  const MEDIA_PROJECTION = createMediaProjection(localeId)
  const LINK_PROJECTION = createLinkProjection(localeId)
  return groq`{
        _key,
        _type,
        ${coalesceLocaleField('title', localeId)},
        ${coalesceLocaleField('description', localeId)},
        anchorId,
        spacing,
        topBorder,
        positions[] {
          _key,
          image${MEDIA_PROJECTION},
          ${coalesceLocaleField('title', localeId)},
          ${coalesceLocaleField('description', localeId)},
          ${coalesceLocaleField('jsonLdDescription', localeId)},
          datePosted,
          validThrough,
          employmentType,
          baseSalary,
          tags[],
          ctaLink${LINK_PROJECTION},
        },
      }
  `
}
